import React from 'react';
import classnames from 'classnames';

import styles from 'signer-app/parts/illustration-lockup/illustration-lockup.module.css';

export type IllustrationLockupProps = React.PropsWithChildren<{
  centered?: boolean; // default false
  illustration: React.ReactElement;
}>;

function IllustrationLockup({
  centered = false,
  illustration,
  children,
}: IllustrationLockupProps) {
  return (
    <div
      className={classnames(styles.container, {
        [styles.centered]: centered,
      })}
    >
      <div className={styles.illustration} aria-hidden>
        {illustration}
      </div>
      <div className={styles.content}>{children}</div>
    </div>
  );
}

export default IllustrationLockup;
